import { createApp } from "vue";
import { createWebHistory, createRouter } from "vue-router";
import { createI18n } from "vue-i18n";
import { VueCookieNext } from "vue-cookie-next";
import App from "./App.vue";
import routes from "@/router";
import store from "./store/index";
import localeData from "./locale.json";

import * as antd from "ant-design-vue";
import "ant-design-vue/dist/antd.css";

// import VueCodemirror from 'vue-codemirror';
// import 'codemirror/lib/codemirror.css';

const routerHistory = createWebHistory();
const router = createRouter({
  history: routerHistory,
  routes: routes,
});

const localStorageLang = localStorage.getItem("language");
const browserLangCode = localStorageLang || (navigator.languages && navigator.languages[0]) || navigator.language;
const language = browserLangCode.toLowerCase().split(/[_-]+/)[0];
localStorage.setItem("language", localStorageLang || language);

const i18n = createI18n({
  legacy: false, // 반드시 추가!
  locale: localStorageLang || language,
  messages: localeData,
});

const app = createApp(App);
app
  .use(store)
  .use(router)
  .use(antd)
  .use(i18n)
  .use(VueCookieNext)
  .mount("#app");
// app.config.devtools = true;
// window.__VUE_DEVTOOLS_GLOBAL_HOOK__.Vue = app.constructor;
